import React from 'react'

import {BASE_NUM_IMAGES} from './GridGallery'
import {Grid, GridItem, StyledSkeletonLoader, Wrapper} from './styles'

export const GridGalleryLoading = () => {
  return (
    <Wrapper>
      <Grid className={`__${BASE_NUM_IMAGES}-images`}>
        {Array.from({length: BASE_NUM_IMAGES}, (_, index) => (
          <GridItem key={index}>
            <StyledSkeletonLoader />
          </GridItem>
        ))}
      </Grid>
    </Wrapper>
  )
}
